import { NotificationSubCategory } from "@/backend/focus";
import { AssociationReactionValue } from "@/utils/constants";

export const ReactionEmoji = {
  [AssociationReactionValue.LIKE]: "👍",
  [AssociationReactionValue.DISLIKE]: "👎",
  [AssociationReactionValue.LOVE]: "❤️",
  [AssociationReactionValue.LAUGH]: "🤣",
  [AssociationReactionValue.ASTONISHED]: "😲",
  [AssociationReactionValue.SAD]: "😢",
  [AssociationReactionValue.ANGRY]: "😠",
};

const LIKE_URL = "/assets/animated-emojis/like.gif";
const DISLIKE_URL = "/assets/animated-emojis/dislike.gif";
const LOVE_URL = "/assets/animated-emojis/love.gif";
const LAUGH_URL = "/assets/animated-emojis/laugh.gif";
const ASTONISHED_URL = "/assets/animated-emojis/astonished.gif";
const SAD_URL = "/assets/animated-emojis/sad.gif";
const ANGRY_URL = "/assets/animated-emojis/angry.gif";

export const ReactionEmojiAnimated = {
  [AssociationReactionValue.LIKE]: LIKE_URL,
  [AssociationReactionValue.DISLIKE]: DISLIKE_URL,
  [AssociationReactionValue.LOVE]: LOVE_URL,
  [AssociationReactionValue.LAUGH]: LAUGH_URL,
  [AssociationReactionValue.ASTONISHED]: ASTONISHED_URL,
  [AssociationReactionValue.SAD]: SAD_URL,
  [AssociationReactionValue.ANGRY]: ANGRY_URL,
};

export const REACTION_EMOJI_NOTIFICATION_MAP = {
  [NotificationSubCategory.REACTION_LIKE]: LIKE_URL,
  [NotificationSubCategory.REACTION_LAUGH]: LAUGH_URL,
  [NotificationSubCategory.REACTION_LOVE]: LOVE_URL,
  [NotificationSubCategory.REACTION_DISLIKE]: DISLIKE_URL,
  [NotificationSubCategory.REACTION_ANGRY]: ANGRY_URL,
  [NotificationSubCategory.REACTION_ASTONISHED]: ASTONISHED_URL,
  [NotificationSubCategory.REACTION_SAD]: SAD_URL,
};

export const REACTION_EMOJI_UTF8_MAP = {
  [NotificationSubCategory.REACTION_LIKE]:
    ReactionEmoji[AssociationReactionValue.LIKE],
  [NotificationSubCategory.REACTION_LAUGH]:
    ReactionEmoji[AssociationReactionValue.LAUGH],
  [NotificationSubCategory.REACTION_LOVE]:
    ReactionEmoji[AssociationReactionValue.LOVE],
  [NotificationSubCategory.REACTION_DISLIKE]:
    ReactionEmoji[AssociationReactionValue.DISLIKE],
  [NotificationSubCategory.REACTION_ANGRY]:
    ReactionEmoji[AssociationReactionValue.ANGRY],
  [NotificationSubCategory.REACTION_ASTONISHED]:
    ReactionEmoji[AssociationReactionValue.ASTONISHED],
  [NotificationSubCategory.REACTION_SAD]:
    ReactionEmoji[AssociationReactionValue.SAD],
};

export type NotificationReactionType =
  | NotificationSubCategory.REACTION_LIKE
  | NotificationSubCategory.REACTION_DISLIKE
  | NotificationSubCategory.REACTION_LOVE
  | NotificationSubCategory.REACTION_LAUGH
  | NotificationSubCategory.REACTION_ASTONISHED
  | NotificationSubCategory.REACTION_SAD
  | NotificationSubCategory.REACTION_ANGRY;
